<i class="fas fa-table-columns"></i> Columns: &nbsp; <p-multiSelect [options]="cols"
[(ngModel)]="selectedCols" optionLabel="header" selectedItemsLabel="{0} columns selected"
[style]="{minWidth:'100px'}" placeholder="Choose Columns" ariaFilterLabel="ColumnFilters"
aria-label="Column Filters" (onChange)="columnsChanged($event)">
</p-multiSelect>
